module.exports = "/dist/ad0e74fca35d6766929fd91189a201ef.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-700italic.woff
// module id = 162
// module chunks = 0